/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { useInvoiceUrl } from 'domain/finance/invoice/shared/useInvoiceRouting';

interface InvoiceLinkProps extends FieldProps {
  nameSource: string;
}

const InvoiceLink = ({ source, nameSource, ...props }: InvoiceLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = useInvoiceUrl();
  const id = getValue();
  const name = getName();

  return <LinkField linkText={name || id} isInternal value={getSingleEntityUrl(id)} {...props} />;
};

export default InvoiceLink;
